import { default as AboutIcon } from "./AboutIcon";
import { default as AccountShieldIcon } from "./AccountShieldIcon";
import { default as AchievementsIcon } from "./AchievementsIcon";
import { default as AddIcon } from "./AddIcon";
import { default as AddToWishlistIcon } from "./AddToWishlistIcon";
import { default as AlertIcon } from "./AlertIcon";
import { default as AlertOutlineIcon } from "./AlertOutlineIcon";
import { default as AnalyticsIcon } from "./AnalyticsIcon";
import { default as AnalyticsShieldIcon } from "./AnalyticsShieldIcon";
import { default as AndroidIcon } from "./AndroidIcon";
import { default as AntiCheatIcon } from "./AntiCheatIcon";
import { default as ArrowFillCircleDownIcon } from "./ArrowFillCircleDownIcon";
import { default as ArrowFillCircleUpIcon } from "./ArrowFillCircleUpIcon";
import { default as ArrowFillDownIcon } from "./ArrowFillDownIcon";
import { default as ArrowFillLeftIcon } from "./ArrowFillLeftIcon";
import { default as ArrowFillRightIcon } from "./ArrowFillRightIcon";
import { default as ArrowFillUpIcon } from "./ArrowFillUpIcon";
import { default as ArrowStrokeDownIcon } from "./ArrowStrokeDownIcon";
import { default as ArrowStrokeLeftIcon } from "./ArrowStrokeLeftIcon";
import { default as ArrowStrokeRightIcon } from "./ArrowStrokeRightIcon";
import { default as ArrowStrokeUpIcon } from "./ArrowStrokeUpIcon";
import { default as ArtifactIcon } from "./ArtifactIcon";
import { default as BannerIcon } from "./BannerIcon";
import { default as BoldIcon } from "./BoldIcon";
import { default as BurgerMenuIcon } from "./BurgerMenuIcon";
import { default as CalendarIcon } from "./CalendarIcon";
import { default as CampaignsIcon } from "./CampaignsIcon";
import { default as CheckIcon } from "./CheckIcon";
import { default as CheckboxCheckedIcon } from "./CheckboxCheckedIcon";
import { default as CheckboxIndeterminateIcon } from "./CheckboxIndeterminateIcon";
import { default as CheckboxUncheckedIcon } from "./CheckboxUncheckedIcon";
import { default as CircleIcon } from "./CircleIcon";
import { default as CloseIcon } from "./CloseIcon";
import { default as CloudSavedIcon } from "./CloudSavedIcon";
import { default as CodeIcon } from "./CodeIcon";
import { default as CollapseIcon } from "./CollapseIcon";
import { default as CopyIcon } from "./CopyIcon";
import { default as CoverIcon } from "./CoverIcon";
import { default as CurrencyIcon } from "./CurrencyIcon";
import { default as DLCIcon } from "./DLCIcon";
import { default as DeleteIcon } from "./DeleteIcon";
import { default as DetailsIcon } from "./DetailsIcon";
import { default as DiscordIcon } from "./DiscordIcon";
import { default as DiscountIcon } from "./DiscountIcon";
import { default as DislikeIcon } from "./DislikeIcon";
import { default as DownloadsIcon } from "./DownloadsIcon";
import { default as DragOutlineIcon } from "./DragOutlineIcon";
import { default as EditIcon } from "./EditIcon";
import { default as EditionsIcon } from "./EditionsIcon";
import { default as EmailIcon } from "./EmailIcon";
import { default as EpicAccountIcon } from "./EpicAccountIcon";
import { default as EpicGamesStoreAnalyticsIcon } from "./EpicGamesStoreAnalyticsIcon";
import { default as EpicIcon } from "./EpicIcon";
import { default as ExpandIcon } from "./ExpandIcon";
import { default as ExternalLinkIcon } from "./ExternalLinkIcon";
import { default as FacebookIcon } from "./FacebookIcon";
import { default as FileIcon } from "./FileIcon";
import { default as FilterIcon } from "./FilterIcon";
import { default as FlagIcon } from "./FlagIcon";
import { default as FolderEmptyIcon } from "./FolderEmptyIcon";
import { default as FolderIcon } from "./FolderIcon";
import { default as FortniteIcon } from "./FortniteIcon";
import { default as FriendsIcon } from "./FriendsIcon";
import { default as GOGIcon } from "./GOGIcon";
import { default as GalleryIcon } from "./GalleryIcon";
import { default as GalleryLayoutIcon } from "./GalleryLayoutIcon";
import { default as GameAnalyticsIcon } from "./GameAnalyticsIcon";
import { default as GameServicesAnalyticsIcon } from "./GameServicesAnalyticsIcon";
import { default as GoogleIcon } from "./GoogleIcon";
import { default as GuidelineIcon } from "./GuidelineIcon";
import { default as GuidelineOutlineIcon } from "./GuidelineOutlineIcon";
import { default as HeadlineIcon } from "./HeadlineIcon";
import { default as HeartIcon } from "./HeartIcon";
import { default as HeartOutlineIcon } from "./HeartOutlineIcon";
import { default as HideIcon } from "./HideIcon";
import { default as HistoryIcon } from "./HistoryIcon";
import { default as HomeIcon } from "./HomeIcon";
import { default as IconsIcon } from "./IconsIcon";
import { default as ImageIcon } from "./ImageIcon";
import { default as InLibraryIcon } from "./InLibraryIcon";
import { default as InWishlistIcon } from "./InWishlistIcon";
import { default as InfoIcon } from "./InfoIcon";
import { default as InstagramIcon } from "./InstagramIcon";
import { default as InventoryIcon } from "./InventoryIcon";
import { default as ItalicIcon } from "./ItalicIcon";
import { default as KWSIcon } from "./KWSIcon";
import { default as KeyIcon } from "./KeyIcon";
import { default as LanguageIcon } from "./LanguageIcon";
import { default as LeaderboardsIcon } from "./LeaderboardsIcon";
import { default as LibraryIcon } from "./LibraryIcon";
import { default as LikeIcon } from "./LikeIcon";
import { default as LinkArrowIcon } from "./LinkArrowIcon";
import { default as LinkIcon } from "./LinkIcon";
import { default as LinkedInIcon } from "./LinkedInIcon";
import { default as ListIcon } from "./ListIcon";
import { default as LobbiesIcon } from "./LobbiesIcon";
import { default as LocalizationIcon } from "./LocalizationIcon";
import { default as LockIcon } from "./LockIcon";
import { default as LogoIcon } from "./LogoIcon";
import { default as MacOSIcon } from "./MacOSIcon";
import { default as ManagementIcon } from "./ManagementIcon";
import { default as MarketingAssetsIcon } from "./MarketingAssetsIcon";
import { default as MatchMakingIcon } from "./MatchMakingIcon";
import { default as MetahumanIcon } from "./MetahumanIcon";
import { default as MinusIcon } from "./MinusIcon";
import { default as MixerIcon } from "./MixerIcon";
import { default as ModShieldIcon } from "./ModShieldIcon";
import { default as ModerationShieldIcon } from "./ModerationShieldIcon";
import { default as ModsIcon } from "./ModsIcon";
import { default as MoreIcon } from "./MoreIcon";
import { default as MyNintendoIcon } from "./MyNintendoIcon";
import { default as NaverIcon } from "./NaverIcon";
import { default as NintendoSwitchIcon } from "./NintendoSwitchIcon";
import { default as NoImageIcon } from "./NoImageIcon";
import { default as NotificationIcon } from "./NotificationIcon";
import { default as OfferIcon } from "./OfferIcon";
import { default as OpenIDIcon } from "./OpenIDIcon";
import { default as OrderedListIcon } from "./OrderedListIcon";
import { default as OrganizationIcon } from "./OrganizationIcon";
import { default as PageIcon } from "./PageIcon";
import { default as ParagraphIcon } from "./ParagraphIcon";
import { default as PauseIcon } from "./PauseIcon";
import { default as PlayIcon } from "./PlayIcon";
import { default as PlayStationCircleIcon } from "./PlayStationCircleIcon";
import { default as PlayStationIcon } from "./PlayStationIcon";
import { default as PlayerDataStorageIcon } from "./PlayerDataStorageIcon";
import { default as PlayerReportsIcon } from "./PlayerReportsIcon";
import { default as PlayersIcon } from "./PlayersIcon";
import { default as PlusIcon } from "./PlusIcon";
import { default as PoliciesIcon } from "./PoliciesIcon";
import { default as PreviewIcon } from "./PreviewIcon";
import { default as ProfileIcon } from "./ProfileIcon";
import { default as ProfileSettingsIcon } from "./ProfileSettingsIcon";
import { default as ProhibitedIcon } from "./ProhibitedIcon";
import { default as QuixelIcon } from "./QuixelIcon";
import { default as QuoteIcon } from "./QuoteIcon";
import { default as RadioButtonCheckedIcon } from "./RadioButtonCheckedIcon";
import { default as RadioButtonUncheckedIcon } from "./RadioButtonUncheckedIcon";
import { default as RedditIcon } from "./RedditIcon";
import { default as ReleaseIcon } from "./ReleaseIcon";
import { default as ResolutionExtraLargeIcon } from "./ResolutionExtraLargeIcon";
import { default as ResolutionLargeIcon } from "./ResolutionLargeIcon";
import { default as ResolutionMediumLandscapeIcon } from "./ResolutionMediumLandscapeIcon";
import { default as ResolutionMediumPortraitIcon } from "./ResolutionMediumPortraitIcon";
import { default as ResolutionSmallIcon } from "./ResolutionSmallIcon";
import { default as RetryIcon } from "./RetryIcon";
import { default as SanctionsIcon } from "./SanctionsIcon";
import { default as SearchIcon } from "./SearchIcon";
import { default as SeasonsIcon } from "./SeasonsIcon";
import { default as ServicesIcon } from "./ServicesIcon";
import { default as ServicesShieldIcon } from "./ServicesShieldIcon";
import { default as SettingsIcon } from "./SettingsIcon";
import { default as SettingsShieldIcon } from "./SettingsShieldIcon";
import { default as ShareIcon } from "./ShareIcon";
import { default as ShowIcon } from "./ShowIcon";
import { default as SnapchatIcon } from "./SnapchatIcon";
import { default as SnoozeIcon } from "./SnoozeIcon";
import { default as SocialIcon } from "./SocialIcon";
import { default as SocialModerationIcon } from "./SocialModerationIcon";
import { default as SocialModerationShieldIcon } from "./SocialModerationShieldIcon";
import { default as SocialPreviewIcon } from "./SocialPreviewIcon";
import { default as SpecificationsIcon } from "./SpecificationsIcon";
import { default as StadiaIcon } from "./StadiaIcon";
import { default as StarIcon } from "./StarIcon";
import { default as StatsIcon } from "./StatsIcon";
import { default as StatusAlertIcon } from "./StatusAlertIcon";
import { default as StatusApprovedIcon } from "./StatusApprovedIcon";
import { default as StatusArchivedIcon } from "./StatusArchivedIcon";
import { default as StatusCheatingIcon } from "./StatusCheatingIcon";
import { default as StatusDeletedIcon } from "./StatusDeletedIcon";
import { default as StatusDelistIcon } from "./StatusDelistIcon";
import { default as StatusDraftedIcon } from "./StatusDraftedIcon";
import { default as StatusEditUnavailableIcon } from "./StatusEditUnavailableIcon";
import { default as StatusEscalatedIcon } from "./StatusEscalatedIcon";
import { default as StatusExpiredIcon } from "./StatusExpiredIcon";
import { default as StatusExploitingIcon } from "./StatusExploitingIcon";
import { default as StatusForgivenessIcon } from "./StatusForgivenessIcon";
import { default as StatusImpersonationIcon } from "./StatusImpersonationIcon";
import { default as StatusInReviewIcon } from "./StatusInReviewIcon";
import { default as StatusOffensiveProfileIcon } from "./StatusOffensiveProfileIcon";
import { default as StatusOthersIcon } from "./StatusOthersIcon";
import { default as StatusPendingReviewIcon } from "./StatusPendingReviewIcon";
import { default as StatusPermanentIcon } from "./StatusPermanentIcon";
import { default as StatusPublishedIcon } from "./StatusPublishedIcon";
import { default as StatusQuarantinedIcon } from "./StatusQuarantinedIcon";
import { default as StatusReadyIcon } from "./StatusReadyIcon";
import { default as StatusScammingIcon } from "./StatusScammingIcon";
import { default as StatusScheduledDelistIcon } from "./StatusScheduledDelistIcon";
import { default as StatusScheduledDelistV2Icon } from "./StatusScheduledDelistV2Icon";
import { default as StatusScheduledDelistV3Icon } from "./StatusScheduledDelistV3Icon";
import { default as StatusSentIcon } from "./StatusSentIcon";
import { default as StatusSpammingIcon } from "./StatusSpammingIcon";
import { default as StatusStagedIcon } from "./StatusStagedIcon";
import { default as StatusSuspiciousIcon } from "./StatusSuspiciousIcon";
import { default as StatusUpdatingIcon } from "./StatusUpdatingIcon";
import { default as SteamIcon } from "./SteamIcon";
import { default as StoreConfigIcon } from "./StoreConfigIcon";
import { default as StorePublishingIcon } from "./StorePublishingIcon";
import { default as StoreShieldIcon } from "./StoreShieldIcon";
import { default as StrikeThroughIcon } from "./StrikeThroughIcon";
import { default as TagIcon } from "./TagIcon";
import { default as TextIcon } from "./TextIcon";
import { default as ThreeLateralIcon } from "./ThreeLateralIcon";
import { default as TicketingIcon } from "./TicketingIcon";
import { default as TitleStorageIcon } from "./TitleStorageIcon";
import { default as ToolsIcon } from "./ToolsIcon";
import { default as TwinmotionIcon } from "./TwinmotionIcon";
import { default as TwitchIcon } from "./TwitchIcon";
import { default as TwitterIcon } from "./TwitterIcon";
import { default as UnrealCircleIcon } from "./UnrealCircleIcon";
import { default as UnrealCircleLineIcon } from "./UnrealCircleLineIcon";
import { default as UnrealIcon } from "./UnrealIcon";
import { default as UplayIcon } from "./UplayIcon";
import { default as UploadIcon } from "./UploadIcon";
import { default as UserIcon } from "./UserIcon";
import { default as VKIcon } from "./VKIcon";
import { default as VideoIcon } from "./VideoIcon";
import { default as ViewCarouselIcon } from "./ViewCarouselIcon";
import { default as VolumeLoudIcon } from "./VolumeLoudIcon";
import { default as VolumeLowIcon } from "./VolumeLowIcon";
import { default as VolumeMuteIcon } from "./VolumeMuteIcon";
import { default as VolumeNormalIcon } from "./VolumeNormalIcon";
import { default as WaitingIcon } from "./WaitingIcon";
import { default as WebIcon } from "./WebIcon";
import { default as WeiboIcon } from "./WeiboIcon";
import { default as WindowsIcon } from "./WindowsIcon";
import { default as XboxIcon } from "./XboxIcon";
import { default as YKIcon } from "./YKIcon";
import { default as YouTubeIcon } from "./YouTubeIcon";
export { AboutIcon, AccountShieldIcon, AchievementsIcon, AddIcon, AddToWishlistIcon, AlertIcon, AlertOutlineIcon, AnalyticsIcon, AnalyticsShieldIcon, AndroidIcon, AntiCheatIcon, ArrowFillCircleDownIcon, ArrowFillCircleUpIcon, ArrowFillDownIcon, ArrowFillLeftIcon, ArrowFillRightIcon, ArrowFillUpIcon, ArrowStrokeDownIcon, ArrowStrokeLeftIcon, ArrowStrokeRightIcon, ArrowStrokeUpIcon, ArtifactIcon, BannerIcon, BoldIcon, BurgerMenuIcon, CalendarIcon, CampaignsIcon, CheckboxCheckedIcon, CheckboxIndeterminateIcon, CheckboxUncheckedIcon, CheckIcon, CircleIcon, CloseIcon, CloudSavedIcon, CodeIcon, CollapseIcon, CopyIcon, CoverIcon, CurrencyIcon, DeleteIcon, DetailsIcon, DiscordIcon, DiscountIcon, DislikeIcon, DLCIcon, DownloadsIcon, DragOutlineIcon, EditIcon, EditionsIcon, EmailIcon, EpicAccountIcon, EpicGamesStoreAnalyticsIcon, EpicIcon, ExpandIcon, ExternalLinkIcon, FacebookIcon, FileIcon, FilterIcon, FlagIcon, FolderEmptyIcon, FolderIcon, FortniteIcon, FriendsIcon, GalleryIcon, GalleryLayoutIcon, GameAnalyticsIcon, GameServicesAnalyticsIcon, GOGIcon, GoogleIcon, GuidelineIcon, GuidelineOutlineIcon, HeadlineIcon, HeartIcon, HeartOutlineIcon, HideIcon, HistoryIcon, HomeIcon, IconsIcon, ImageIcon, InfoIcon, InLibraryIcon, InstagramIcon, InventoryIcon, InWishlistIcon, ItalicIcon, KeyIcon, KWSIcon, LanguageIcon, LeaderboardsIcon, LibraryIcon, LikeIcon, LinkArrowIcon, LinkedInIcon, LinkIcon, ListIcon, LobbiesIcon, LocalizationIcon, LockIcon, LogoIcon, MacOSIcon, ManagementIcon, MatchMakingIcon, MarketingAssetsIcon, MetahumanIcon, MinusIcon, MixerIcon, ModerationShieldIcon, ModShieldIcon, ModsIcon, MoreIcon, MyNintendoIcon, NaverIcon, NintendoSwitchIcon, NoImageIcon, NotificationIcon, OfferIcon, OpenIDIcon, OrderedListIcon, OrganizationIcon, PageIcon, ParagraphIcon, PauseIcon, PlayerDataStorageIcon, PlayerReportsIcon, PlayersIcon, PlayIcon, PlayStationCircleIcon, PlayStationIcon, PlusIcon, PoliciesIcon, PreviewIcon, ProfileIcon, ProfileSettingsIcon, ProhibitedIcon, QuixelIcon, QuoteIcon, RadioButtonCheckedIcon, RadioButtonUncheckedIcon, RedditIcon, ReleaseIcon, ResolutionExtraLargeIcon, ResolutionLargeIcon, ResolutionMediumLandscapeIcon, ResolutionMediumPortraitIcon, ResolutionSmallIcon, RetryIcon, SanctionsIcon, SearchIcon, SeasonsIcon, ServicesIcon, ServicesShieldIcon, SettingsIcon, SettingsShieldIcon, ShareIcon, ShowIcon, SnapchatIcon, SnoozeIcon, SocialIcon, SocialModerationIcon, SocialModerationShieldIcon, SocialPreviewIcon, SpecificationsIcon, StadiaIcon, StarIcon, StatsIcon, StatusAlertIcon, StatusApprovedIcon, StatusArchivedIcon, StatusCheatingIcon, StatusDeletedIcon, StatusDelistIcon, StatusDraftedIcon, StatusEditUnavailableIcon, StatusEscalatedIcon, StatusExpiredIcon, StatusExploitingIcon, StatusForgivenessIcon, StatusImpersonationIcon, StatusInReviewIcon, StatusOffensiveProfileIcon, StatusOthersIcon, StatusPendingReviewIcon, StatusPermanentIcon, StatusPublishedIcon, StatusQuarantinedIcon, StatusReadyIcon, StatusScheduledDelistIcon, StatusScheduledDelistV2Icon, StatusScheduledDelistV3Icon, StatusSentIcon, StatusScammingIcon, StatusSpammingIcon, StatusStagedIcon, StatusSuspiciousIcon, StatusUpdatingIcon, SteamIcon, StoreConfigIcon, StorePublishingIcon, StoreShieldIcon, StrikeThroughIcon, TagIcon, TextIcon, ThreeLateralIcon, TicketingIcon, TitleStorageIcon, ToolsIcon, TwinmotionIcon, TwitchIcon, TwitterIcon, UnrealCircleIcon, UnrealCircleLineIcon, UnrealIcon, UplayIcon, UploadIcon, UserIcon, VideoIcon, ViewCarouselIcon, VKIcon, VolumeLoudIcon, VolumeLowIcon, VolumeMuteIcon, VolumeNormalIcon, WaitingIcon, WebIcon, WeiboIcon, WindowsIcon, XboxIcon, YKIcon, YouTubeIcon, };
/** @deprecated use the suffixed `AboutIcon` instead */
export var About = AboutIcon;
/** @deprecated use the suffixed `AccountShieldIcon` instead */
export var AccountShield = AccountShieldIcon;
/** @deprecated use the suffixed `AchievementsIcon` instead */
export var Achievements = AchievementsIcon;
/** @deprecated use the suffixed `AddIcon` instead */
export var Add = AddIcon;
/** @deprecated use the suffixed `AddToWishlistIcon` instead */
export var AddToWishlist = AddToWishlistIcon;
/** @deprecated use the suffixed `AlertIcon` instead */
export var Alert = AlertIcon;
/** @deprecated use the suffixed `AlertOutlineIcon` instead */
export var AlertOutline = AlertOutlineIcon;
/** @deprecated use the suffixed `AnalyticsIcon` instead */
export var Analytics = AnalyticsIcon;
/** @deprecated use the suffixed `AnalyticsShieldIcon` instead */
export var AnalyticsShield = AnalyticsShieldIcon;
/** @deprecated use the suffixed `AndroidIcon` instead */
export var Android = AndroidIcon;
/** @deprecated use the suffixed `ArrowFillCircleDown` instead */
export var ArrowFillCircleDown = ArrowFillCircleDownIcon;
/** @deprecated use the suffixed `ArrowFillCircleUpIcon` instead */
export var ArrowFillCircleUp = ArrowFillCircleUpIcon;
/** @deprecated use the suffixed `ArrowFillDownIcon` instead */
export var ArrowFillDown = ArrowFillDownIcon;
/** @deprecated use the suffixed `ArrowFillLeftIcon` instead */
export var ArrowFillLeft = ArrowFillLeftIcon;
/** @deprecated use the suffixed `ArrowFillRightIcon` instead */
export var ArrowFillRight = ArrowFillRightIcon;
/** @deprecated use the suffixed `ArrowFillUpIcon` instead */
export var ArrowFillUp = ArrowFillUpIcon;
/** @deprecated use the suffixed `ArrowStrokeDownIcon` instead */
export var ArrowStrokeDown = ArrowStrokeDownIcon;
/** @deprecated use the suffixed `ArrowStrokeLeftIcon` instead */
export var ArrowStrokeLeft = ArrowStrokeLeftIcon;
/** @deprecated use the suffixed `ArrowStrokeRightIcon` instead */
export var ArrowStrokeRight = ArrowStrokeRightIcon;
/** @deprecated use the suffixed `ArrowStrokeUpIcon` instead */
export var ArrowStrokeUp = ArrowStrokeUpIcon;
/** @deprecated use the suffixed `ArtifactIcon` instead */
export var Artifact = ArtifactIcon;
/** @deprecated use the suffixed `BannerIcon` instead */
export var Banner = BannerIcon;
/** @deprecated use the suffixed `BoldIcon` instead */
export var Bold = BoldIcon;
/** @deprecated use the suffixed `BurgerMenuIcon` instead */
export var BurgerMenu = BurgerMenuIcon;
/** @deprecated use the suffixed `CalendarIcon` instead */
export var Calendar = CalendarIcon;
/** @deprecated use the suffixed `CheckIcon` instead */
export var Check = CheckIcon;
/** @deprecated use the suffixed `CheckboxCheckedIcon` instead */
export var CheckboxChecked = CheckboxCheckedIcon;
/** @deprecated use the suffixed `CheckboxIndetermi` instead */
export var CheckboxIndeterminate = CheckboxIndeterminateIcon;
/** @deprecated use the suffixed `CheckboxUncheckedIcon` instead */
export var CheckboxUnchecked = CheckboxUncheckedIcon;
/** @deprecated use the suffixed `CircleIcon` instead */
export var Circle = CircleIcon;
/** @deprecated use the suffixed `CloseIcon` instead */
export var Close = CloseIcon;
/** @deprecated use the suffixed `CloudSavedIcon` instead */
export var CloudSaved = CloudSavedIcon;
/** @deprecated use the suffixed `CodeIcon` instead */
export var Code = CodeIcon;
/** @deprecated use the suffixed `CollapseIcon` instead */
export var Collapse = CollapseIcon;
/** @deprecated use the suffixed `CopyIcon` instead */
export var Copy = CopyIcon;
/** @deprecated use the suffixed `CoverIcon` instead */
export var Cover = CoverIcon;
/** @deprecated use the suffixed `CurrencyIcon` instead */
export var Currency = CurrencyIcon;
/** @deprecated use the suffixed `DeleteIcon` instead */
export var Delete = DeleteIcon;
/** @deprecated use the suffixed `DetailsIcon` instead */
export var Details = DetailsIcon;
/** @deprecated use the suffixed `DiscordIcon` instead */
export var Discord = DiscordIcon;
/** @deprecated use the suffixed `DiscountIcon` instead */
export var Discount = DiscountIcon;
/** @deprecated use the suffixed `DislikeIcon` instead */
export var Dislike = DislikeIcon;
/** @deprecated use the suffixed `DLCIcon` instead */
export var DLC = DLCIcon;
/** @deprecated use the suffixed `DownloadsIcon` instead */
export var Downloads = DownloadsIcon;
/** @deprecated use the suffixed `DragOutlineIcon` instead */
export var DragOutline = DragOutlineIcon;
/** @deprecated use the suffixed `EditIcon` instead */
export var Edit = EditIcon;
/** @deprecated use the suffixed `EditionsIcon` instead */
export var Editions = EditionsIcon;
/** @deprecated use the suffixed `EmailIcon` instead */
export var Email = EmailIcon;
/** @deprecated use the suffixed `EpicIcon` instead */
export var Epic = EpicIcon;
/** @deprecated use the suffixed `EpicAccountIcon` instead */
export var EpicAccount = EpicAccountIcon;
/** @deprecated use the suffixed `ExpandIcon` instead */
export var Expand = ExpandIcon;
/** @deprecated use the suffixed `ExternalLinkIcon` instead */
export var ExternalLink = ExternalLinkIcon;
/** @deprecated use the suffixed `FacebookIcon` instead */
export var Facebook = FacebookIcon;
/** @deprecated use the suffixed `FileIcon` instead */
export var File = FileIcon;
/** @deprecated use the suffixed `FilterIcon` instead */
export var Filter = FilterIcon;
/** @deprecated use the suffixed `FolderIcon` instead */
export var Folder = FolderIcon;
/** @deprecated use the suffixed `FolderEmptyIcon` instead */
export var FolderEmpty = FolderEmptyIcon;
/** @deprecated use the suffixed `FortniteIcon` instead */
export var Fortnite = FortniteIcon;
/** @deprecated use the suffixed `FriendsIcon` instead */
export var Friends = FriendsIcon;
/** @deprecated use the suffixed `GalleryIcon` instead */
export var Gallery = GalleryIcon;
/** @deprecated use the suffixed `GalleryLayoutIcon` instead */
export var GalleryLayout = GalleryLayoutIcon;
/** @deprecated use the suffixed `GOGIcon` instead */
export var GOG = GOGIcon;
/** @deprecated use the suffixed `GoogleIcon` instead */
export var Google = GoogleIcon;
/** @deprecated use the suffixed `GuidelineIcon` instead */
export var Guideline = GuidelineIcon;
/** @deprecated use the suffixed `GuidelineOutlineIcon` instead */
export var GuidelineOutline = GuidelineOutlineIcon;
/** @deprecated use the suffixed `HeadlineIcon` instead */
export var Headline = HeadlineIcon;
/** @deprecated use the suffixed `HeartIcon` instead */
export var Heart = HeartIcon;
/** @deprecated use the suffixed `HeartOutlineIcon` instead */
export var HeartOutline = HeartOutlineIcon;
/** @deprecated use the suffixed `HideIcon` instead */
export var Hide = HideIcon;
/** @deprecated use the suffixed `HistoryIcon` instead */
export var History = HistoryIcon;
/** @deprecated use the suffixed `HomeIcon` instead */
export var Home = HomeIcon;
/** @deprecated use the suffixed `IconsIcon` instead */
export var Icons = IconsIcon;
/** @deprecated use the suffixed `ImageIcon` instead */
export var Image = ImageIcon;
/** @deprecated use the suffixed `InfoIcon` instead */
export var Info = InfoIcon;
/** @deprecated use the suffixed `InLibraryIcon` instead */
export var InLibrary = InLibraryIcon;
/** @deprecated use the suffixed `InstagramIcon` instead */
export var Instagram = InstagramIcon;
/** @deprecated use the suffixed `InWishlistIcon` instead */
export var InWishlist = InWishlistIcon;
/** @deprecated use the suffixed `ItalicIcon` instead */
export var Italic = ItalicIcon;
/** @deprecated use the suffixed `KWSIcon` instead */
export var KWS = KWSIcon;
/** @deprecated use the suffixed `LeaderboardsIcon` instead */
export var Leaderboards = LeaderboardsIcon;
/** @deprecated use the suffixed `LibraryIcon` instead */
export var Library = LibraryIcon;
/** @deprecated use the suffixed `LikeIcon` instead */
export var Like = LikeIcon;
/** @deprecated use the suffixed `LinkIcon` instead */
export var Link = LinkIcon;
/** @deprecated use the suffixed `LinkArrowIcon` instead */
export var LinkArrow = LinkArrowIcon;
/** @deprecated use the suffixed `LinkedInIcon` instead */
export var LinkedIn = LinkedInIcon;
/** @deprecated use the suffixed `ListIcon` instead */
export var List = ListIcon;
/** @deprecated use the suffixed `LocalizationIcon` instead */
export var Localization = LocalizationIcon;
/** @deprecated use the suffixed `LogoIcon` instead */
export var Logo = LogoIcon;
/** @deprecated use the suffixed `MacOSIcon` instead */
export var MacOS = MacOSIcon;
/** @deprecated use the suffixed `ManagementIcon` instead */
export var Management = ManagementIcon;
/** @deprecated use the suffixed `MetahumanIcon` instead */
export var Metahuman = MetahumanIcon;
/** @deprecated use the suffixed `MinusIcon` instead */
export var Minus = MinusIcon;
/** @deprecated use the suffixed `MixerIcon` instead */
export var Mixer = MixerIcon;
/** @deprecated use the suffixed `ModerationShieldIcon` instead */
export var ModerationShield = ModerationShieldIcon;
/** @deprecated use the suffixed `ModsIcon` instead */
export var Mods = ModsIcon;
/** @deprecated use the suffixed `ModShieldIcon` instead */
export var ModShield = ModShieldIcon;
/** @deprecated use the suffixed `MoreIcon` instead */
export var More = MoreIcon;
/** @deprecated use the suffixed `MyNintendoIcon` instead */
export var MyNintendo = MyNintendoIcon;
/** @deprecated use the suffixed `NaverIcon` instead */
export var Naver = NaverIcon;
/** @deprecated use the suffixed `NintendoSwitchIcon` instead */
export var NintendoSwitch = NintendoSwitchIcon;
/** @deprecated use the suffixed `NoImageIcon` instead */
export var NoImage = NoImageIcon;
/** @deprecated use the suffixed `NotificationIcon` instead */
export var Notification = NotificationIcon;
/** @deprecated use the suffixed `OfferIcon` instead */
export var Offer = OfferIcon;
/** @deprecated use the suffixed `OpenIDIcon` instead */
export var OpenID = OpenIDIcon;
/** @deprecated use the suffixed `OrderedListIcon` instead */
export var OrderedList = OrderedListIcon;
/** @deprecated use the suffixed `OrganizationIcon` instead */
export var Organization = OrganizationIcon;
/** @deprecated use the suffixed `PageIcon` instead */
export var Page = PageIcon;
/** @deprecated use the suffixed `ParagraphIcon` instead */
export var Paragraph = ParagraphIcon;
/** @deprecated use the suffixed `PauseIcon` instead */
export var Pause = PauseIcon;
/** @deprecated use the suffixed `PlayIcon` instead */
export var Play = PlayIcon;
/** @deprecated use the suffixed `PlayersIcon` instead */
export var Players = PlayersIcon;
/** @deprecated use the suffixed `PlayStationIcon` instead */
export var PlayStation = PlayStationIcon;
/** @deprecated use the suffixed `PlayStationCircleIcon` instead */
export var PlayStationCircle = PlayStationCircleIcon;
/** @deprecated use the suffixed `PlusIcon` instead */
export var Plus = PlusIcon;
/** @deprecated use the suffixed `PoliciesIcon` instead */
export var Policies = PoliciesIcon;
/** @deprecated use the suffixed `PreviewIcon` instead */
export var Preview = PreviewIcon;
/** @deprecated use the suffixed `ProfileIcon` instead */
export var Profile = ProfileIcon;
/** @deprecated use the suffixed `ProfileSettingsIcon` instead */
export var ProfileSettings = ProfileSettingsIcon;
/** @deprecated use the suffixed `ProhibitedIcon` instead */
export var Prohibited = ProhibitedIcon;
/** @deprecated use the suffixed `StatusPublishedIcon` instead */
export var Published = StatusPublishedIcon;
/** @deprecated use the suffixed `StatusPublishedIcon` instead */
export var PublishedIcon = StatusPublishedIcon;
/** @deprecated use the suffixed `QuixelIcon` instead */
export var Quixel = QuixelIcon;
/** @deprecated use the suffixed `QuoteIcon` instead */
export var Quote = QuoteIcon;
/** @deprecated use the suffixed `RadioButtonCheckedIc` instead */
export var RadioButtonChecked = RadioButtonCheckedIcon;
/** @deprecated use the suffixed `RadioButtonUncheck` instead */
export var RadioButtonUnchecked = RadioButtonUncheckedIcon;
/** @deprecated use the suffixed `RedditIcon` instead */
export var Reddit = RedditIcon;
/** @deprecated use the suffixed `ResolutionExtraLar` instead */
export var ResolutionExtraLarge = ResolutionExtraLargeIcon;
/** @deprecated use the suffixed `ResolutionLargeIcon` instead */
export var ResolutionLarge = ResolutionLargeIcon;
/** @deprecated use the suffixed `ResolutionMed` instead */
export var ResolutionMediumLandscape = ResolutionMediumLandscapeIcon;
/** @deprecated use the suffixed `ResolutionMedi` instead */
export var ResolutionMediumPortrait = ResolutionMediumPortraitIcon;
/** @deprecated use the suffixed `ResolutionSmallIcon` instead */
export var ResolutionSmall = ResolutionSmallIcon;
/** @deprecated use the suffixed `RetryIcon` instead */
export var Retry = RetryIcon;
/** @deprecated use the suffixed `SearchIcon` instead */
export var Search = SearchIcon;
/** @deprecated use the suffixed `SeasonsIcon` instead */
export var Seasons = SeasonsIcon;
/** @deprecated use the suffixed `ServicesIcon` instead */
export var Services = ServicesIcon;
/** @deprecated use the suffixed `ServicesShieldIcon` instead */
export var ServicesShield = ServicesShieldIcon;
/** @deprecated use the suffixed `SettingsIcon` instead */
export var Settings = SettingsIcon;
/** @deprecated use the suffixed `SettingsShieldIcon` instead */
export var SettingsShield = SettingsShieldIcon;
/** @deprecated use the suffixed `ShareIcon` instead */
export var Share = ShareIcon;
/** @deprecated use the suffixed `ShowIcon` instead */
export var Show = ShowIcon;
/** @deprecated use the suffixed `SnapchatIcon` instead */
export var Snapchat = SnapchatIcon;
/** @deprecated use the suffixed `SnoozeIcon` instead */
export var Snooze = SnoozeIcon;
/** @deprecated use the suffixed `SocialIcon` instead */
export var Social = SocialIcon;
/** @deprecated use the suffixed `SocialModerationIcon` instead */
export var SocialModeration = SocialModerationIcon;
/** @deprecated use the suffixed `SocialModeration` instead */
export var SocialModerationShield = SocialModerationShieldIcon;
/** @deprecated use the suffixed `SpecificationsIcon` instead */
export var Specifications = SpecificationsIcon;
/** @deprecated use the suffixed `StadiaIcon` instead */
export var Stadia = StadiaIcon;
/** @deprecated use the suffixed `StarIcon` instead */
export var Star = StarIcon;
/** @deprecated use the suffixed `StatusAlertIcon` instead */
export var StatusAlert = StatusAlertIcon;
/** @deprecated use the suffixed `StatusApprovedIcon` instead */
export var StatusApproved = StatusApprovedIcon;
/** @deprecated use the suffixed `StatusArchivedIcon` instead */
export var StatusArchived = StatusArchivedIcon;
/** @deprecated use the suffixed `StatusDelistIcon` instead */
export var StatusDelist = StatusDelistIcon;
/** @deprecated use the suffixed `StatusDraftedIcon` instead */
export var StatusDrafted = StatusDraftedIcon;
/** @deprecated use the suffixed `StatusEscalatedIcon` instead */
export var StatusEscalated = StatusEscalatedIcon;
/** @deprecated use the suffixed `StatusInReviewIcon` instead */
export var StatusInReview = StatusInReviewIcon;
/** @deprecated use the suffixed `StatusPendingReview` instead */
export var StatusPendingReview = StatusPendingReviewIcon;
/** @deprecated use the suffixed `StatusQuarantinedIcon` instead */
export var StatusQuarantined = StatusQuarantinedIcon;
/** @deprecated use the suffixed `StatusReadyIcon` instead */
export var StatusReady = StatusReadyIcon;
/** @deprecated use the suffixed `StatusScheduledDe` instead */
export var StatusScheduledDelist = StatusScheduledDelistIcon;
/** @deprecated use the suffixed `StatusScheduled` instead */
export var StatusScheduledDelistV2 = StatusScheduledDelistV2Icon;
/** @deprecated use the suffixed `StatusScheduled` instead */
export var StatusScheduledDelistV3 = StatusScheduledDelistV3Icon;
/** @deprecated use the suffixed `StatusSentIcon` instead */
export var StatusSent = StatusSentIcon;
/** @deprecated use the suffixed `StatusStagedIcon` instead */
export var StatusStaged = StatusStagedIcon;
/** @deprecated use the suffixed `StatusSuspiciousIcon` instead */
export var StatusSuspicious = StatusSuspiciousIcon;
/** @deprecated use the suffixed `StatusEditUnavail` instead */
export var StatusEditUnavailable = StatusEditUnavailableIcon;
/** @deprecated use the suffixed `StatusUpdatingIcon` instead */
export var StatusUpdating = StatusUpdatingIcon;
/** @deprecated use the suffixed `SteamIcon` instead */
export var Steam = SteamIcon;
/** @deprecated use the suffixed `StoreConfigIcon` instead */
export var StoreConfig = StoreConfigIcon;
/** @deprecated use the suffixed `StorePublishingIcon` instead */
export var StorePublishing = StorePublishingIcon;
/** @deprecated use the suffixed `StoreShieldIcon` instead */
export var StoreShield = StoreShieldIcon;
/** @deprecated use the suffixed `StrikeThroughIcon` instead */
export var StrikeThrough = StrikeThroughIcon;
/** @deprecated use the suffixed `TagIcon` instead */
export var Tag = TagIcon;
/** @deprecated use the suffixed `TextIcon` instead */
export var Text = TextIcon;
/** @deprecated use the suffixed `ThreeLateralIcon` instead */
export var ThreeLateral = ThreeLateralIcon;
/** @deprecated use the suffixed `ToolsIcon` instead */
export var Tools = ToolsIcon;
/** @deprecated use the suffixed `TwinmotionIcon` instead */
export var Twinmotion = TwinmotionIcon;
/** @deprecated use the suffixed `TwitchIcon` instead */
export var Twitch = TwitchIcon;
/** @deprecated use the suffixed `TwitterIcon` instead */
export var Twitter = TwitterIcon;
/** @deprecated use the suffixed `UnrealIcon` instead */
export var Unreal = UnrealIcon;
/** @deprecated use the suffixed `UnrealCircleIcon` instead */
export var UnrealCircle = UnrealCircleIcon;
/** @deprecated use the suffixed `UnrealCircleLineIcon` instead */
export var UnrealCircleLine = UnrealCircleLineIcon;
/** @deprecated use the suffixed `UplayIcon` instead */
export var Uplay = UplayIcon;
/** @deprecated use the suffixed `UploadIcon` instead */
export var Upload = UploadIcon;
/** @deprecated use the suffixed `UserIcon` instead */
export var User = UserIcon;
/** @deprecated use the suffixed `VideoIcon` instead */
export var Video = VideoIcon;
/** @deprecated use the suffixed `ViewCarouselIcon` instead */
export var ViewCarousel = ViewCarouselIcon;
/** @deprecated use the suffixed `VKIcon` instead */
export var VK = VKIcon;
/** @deprecated use the suffixed `VolumeLoudIcon` instead */
export var VolumeLoud = VolumeLoudIcon;
/** @deprecated use the suffixed `VolumeLowIcon` instead */
export var VolumeLow = VolumeLowIcon;
/** @deprecated use the suffixed `VolumeMuteIcon` instead */
export var VolumeMute = VolumeMuteIcon;
/** @deprecated use the suffixed `VolumeNormalIcon` instead */
export var VolumeNormal = VolumeNormalIcon;
/** @deprecated use the suffixed `WaitingIcon` instead */
export var Waiting = WaitingIcon;
/** @deprecated use the suffixed `WebIcon` instead */
export var Web = WebIcon;
/** @deprecated use the suffixed `WeiboIcon` instead */
export var Weibo = WeiboIcon;
/** @deprecated use the suffixed `WindowsIcon` instead */
export var Windows = WindowsIcon;
/** @deprecated use the suffixed `XboxIcon` instead */
export var Xbox = XboxIcon;
/** @deprecated use the suffixed `YKIcon` instead */
export var YK = YKIcon;
/** @deprecated use the suffixed `YouTubeIcon` instead */
export var YouTube = YouTubeIcon;
//# sourceMappingURL=index.js.map